/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_PreviousInputs */

const en_us2_progress_report_previous = /** @type {(inputs: Progress_Report_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous period`)
};

const pt_br2_progress_report_previous = /** @type {(inputs: Progress_Report_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Período anterior`)
};

const es_419_progress_report_previous = /** @type {(inputs: Progress_Report_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Período anterior`)
};

const pt_pt2_progress_report_previous = /** @type {(inputs: Progress_Report_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Período anterior`)
};

const fr_fr2_progress_report_previous = /** @type {(inputs: Progress_Report_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Période précédente`)
};

const de_de2_progress_report_previous = /** @type {(inputs: Progress_Report_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorheriger Zeitraum`)
};

const it_it2_progress_report_previous = /** @type {(inputs: Progress_Report_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periodo precedente`)
};

/**
* | output |
* | --- |
* | "Previous period" |
*
* @param {Progress_Report_PreviousInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_previous = /** @type {((inputs?: Progress_Report_PreviousInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_PreviousInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_previous(inputs)
	if (locale === "es-419") return es_419_progress_report_previous(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_previous(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_previous(inputs)
	if (locale === "de-DE") return de_de2_progress_report_previous(inputs)
	if (locale === "it-IT") return it_it2_progress_report_previous(inputs)
	return en_us2_progress_report_previous(inputs)
});
export { progress_report_previous as "progress-report.previous" }